import { apiGet, apiPatch, apiPost } from './client';
import type { Ticket, TicketStatus, TicketPriority } from '../types';

export async function getTickets(): Promise<Ticket[]> {
  return apiGet<Ticket[]>('/tickets');
}

export async function getTicket(id: string): Promise<Ticket> {
  return apiGet<Ticket>(`/tickets/${id}`);
}

export async function createTicket(data: {
  customerId: string;
  conversationId: string;
  departmentId: string;
  subject: string;
}): Promise<Ticket> {
  return apiPost<Ticket>('/tickets', data);
}

export async function updateTicketStatus(id: string, status: TicketStatus, priority?: TicketPriority): Promise<Ticket> {
  return apiPatch<Ticket>(`/tickets/${id}/status`, { status, priority });
}
